// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton"; // Import hinzugefügt
import PropTypes from "prop-types"; // PropTypes hinzugefügt

function About({ onNext }) {
  return (
    <SoftBox>
      <SoftBox width="80%" textAlign="center" mx="auto" mb={4}>
        <SoftTypography variant="h4" fontWeight="bold">
          UDS Cloud Storage
        </SoftTypography>
        <SoftTypography variant="body1" fontWeight="regular" color="text">
          UDS Cloud Storage bietet eine zuverlässige, skalierbare und sichere Lösung für Ihre
          Speicheranforderungen. Mit modernster Technologie und einfacher Integration ist es die
          ideale Wahl für Unternehmen jeder Größe.
        </SoftTypography>
      </SoftBox>
      <SoftBox mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Hauptmerkmale
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - Hohe Verfügbarkeit und Zuverlässigkeit <br />
              - Flexible Skalierungsmöglichkeiten <br />
              - Einfache Integration in bestehende Systeme
            </SoftTypography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Vorteile
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - Kosteneffizient und sicher <br />
              - Unterstützung durch ein erfahrenes Team <br />
              - Anpassbar an individuelle Anforderungen
            </SoftTypography>
          </Grid>
        </Grid>
      </SoftBox>
      <SoftBox mt={4} textAlign="center">
        <SoftButton color="primary" onClick={onNext}>
          Weiter
        </SoftButton>
      </SoftBox>
    </SoftBox>
  );
}

About.propTypes = {
  onNext: PropTypes.func.isRequired, // PropTypes hinzugefügt
};

export default About;
